import { __awaiter, __generator } from "tslib";
import Axios from 'axios';
import store from "../store";
import { createClient } from './serviceProxy';
var ENDPOINT_NOTIFICATION_SEND = '/notification/sms/send';
var ENDPOINT_NOTIFICATION_VALID = '/notification/validCode';
export default (function (_a) {
    var apikey = _a.apikey;
    var client = createClient({ apikey: apikey });
    var checkValidCode = function (phoneNumber, userValidCode) { return __awaiter(void 0, void 0, Promise, function () {
        var response, e_1;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    _a.trys.push([0, 2, , 3]);
                    return [4 /*yield*/, client.get("" + ENDPOINT_NOTIFICATION_VALID, {
                            params: {
                                recipient: phoneNumber,
                                validCode: userValidCode
                            }
                        })];
                case 1:
                    response = _a.sent();
                    return [3 /*break*/, 3];
                case 2:
                    e_1 = _a.sent();
                    if (Axios.isCancel(e_1))
                        return [2 /*return*/, null];
                    return [2 /*return*/, e_1.message];
                case 3: return [2 /*return*/, response ? response.data : null];
            }
        });
    }); };
    var sendValidSMS = function (phoneNumber) { return __awaiter(void 0, void 0, Promise, function () {
        var response, formData, e_2;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    _a.trys.push([0, 2, , 3]);
                    formData = {
                        "sender": store.states.mobileNumberValidationSender || "MyShop",
                        "recipient": phoneNumber,
                        "content": store.states.mobileNumberValidationMessage || "#uuid# ist Ihr Code zur Verifizierung Ihrer Mobilnummer"
                    };
                    return [4 /*yield*/, client.post("" + ENDPOINT_NOTIFICATION_SEND, formData)];
                case 1: return [2 /*return*/, _a.sent()];
                case 2:
                    e_2 = _a.sent();
                    if (Axios.isCancel(e_2))
                        return [2 /*return*/, null];
                    return [2 /*return*/, e_2.message];
                case 3: 
                // @ts-ignore
                return [2 /*return*/, response ? response.data : null];
            }
        });
    }); };
    return { checkValidCode: checkValidCode, sendValidSMS: sendValidSMS };
});
